<template>
  <MainHeader />
  <MainSidebar />
  <div class="main-content bg_gray d-flex flex-column transition overflow-hidden">
    <BreadcrumbMenu
      pageTitle="create_transfer"
      :items="breadcrumbItems"
      :showHome="false"
    />

    <ChooseForm
      :warehouses="warehouses"
      v-model:fromWarehouseId="form.from_warehouse_id"
      v-model:toWarehouseId="form.to_warehouse_id"
      :referenceNo="form.ref"
      :date="form.date"
      :fromWarehouseLocked="fromWarehouseLockedToProfile"
      :isLoading="isLoadingData"
      @search-product="handleProductSearch"
      :searchResults="searchResults"
      :showResults="showResults"
      @add-product="addProduct"
    />

    <SelectedProducts
      :items="items"
      @remove-item="removeItem"
      @update-qty="updateQty"
    />

    <CreateTransferFrom
      :form="form"
      :items="items"
      :total-qty="totalQty"
      :sub-total="subTotal"
      :grand-total="grandTotal"
      @submit="submitTransfer"
      @update:formKey="updateForm"
    />

    <div class="flex-grow-1"></div>
    <MainFooter />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import MainHeader from "../../components/Layouts/MainHeader.vue";
import MainSidebar from "../../components/Layouts/MainSidebar.vue";
import BreadcrumbMenu from "../../components/Common/BreadcrumbMenu.vue";
import ChooseForm from "../../components/Transfer/CreateTransfer/ChooseForm.vue";
import SelectedProducts from "../../components/Transfer/CreateTransfer/SelectedProducts.vue";
import CreateTransferFrom from "../../components/Transfer/CreateTransfer/CreateTransferFrom.vue";
import MainFooter from "../../components/Layouts/MainFooter.vue";
import { useTransferForm } from "../../composables/useTransfer";

export default defineComponent({
  name: "CreateTransferPage",
  components: {
    MainHeader,
    MainSidebar,
    BreadcrumbMenu,
    ChooseForm,
    SelectedProducts,
    CreateTransferFrom,
    MainFooter,
  },
  setup() {
    return useTransferForm();
  },
});
</script>
